import {
  breakpointSizes,
  getBreakpointOnly,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment, useState } from 'react'
import Box from 'src/components/Box/Box'
import Collapsible from 'src/components/Collapsible/Collapsible'
import SvgChevronDown from 'src/components/Svgs/SvgChevronDown'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'
import { css } from 'styled-components'

interface CollapsibleMiddleBoxProps {
  className?: string
  topContent: React.ReactElement
  middleContent?: React.ReactElement
  bottomContent?: {
    closedBottomLabel: React.ReactElement
    openBottomLabel: React.ReactElement
  }
}

const CollapsibleMiddleBox: React.FC<CollapsibleMiddleBoxProps> = (
  props,
): React.ReactElement => {
  const [isMiddleContentOpen, setIsMiddleContentOpen] = useState(false)
  const onBottomClick = (): void => {
    setIsMiddleContentOpen(!isMiddleContentOpen)
  }

  return (
    <Box
      className={props.className}
      noPadding
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          ${(props.middleContent !== undefined ||
            props.bottomContent !== undefined) &&
          css`
            border-bottom: 1px solid ${styleConstants.colors.gray_light};
          `}
        `}
      >
        {props.topContent}
      </div>
      {props.middleContent !== undefined && (
        <Collapsible
          css={css`
            background-color: ${styleConstants.colors.gray_lightest};
          `}
          isOpen={isMiddleContentOpen}
        >
          {props.middleContent}
        </Collapsible>
      )}
      {props.bottomContent !== undefined && (
        <div
          data-testid={props.className + 'ExpandBoxToggle'}
          onClick={onBottomClick}
          onKeyPress={onBottomClick}
          role="button"
          tabIndex={0}
          css={css`
            transition: background-color ${styleConstants.transitionSpeed.fast}
              ease-out;
            border-bottom-left-radius: ${styleConstants.borderRadius.box};
            border-bottom-right-radius: ${styleConstants.borderRadius.box};
            cursor: pointer;
            background-color: ${styleConstants.colors.gray_lightest};

            padding: 20px ${styleConstants.widths.cardPaddingXSMUp};
            ${getBreakpointOnly(breakpointSizes.XXSM)(css`
              padding: 20px ${styleConstants.widths.cardPaddingXXSMOnly};
            `)}

            span {
              transition: color ${styleConstants.transitionSpeed.fast} ease-out;
            }

            svg path {
              transition: fill ${styleConstants.transitionSpeed.fast} ease-out;
            }

            &:hover {
              background-color: ${themeConstants.colors.cta};

              span {
                color: ${styleConstants.colors.white};
              }

              svg path {
                fill: ${styleConstants.colors.white};
              }
            }
          `}
        >
          <span
            css={css`
              ${getFontCss(
                14,
                themeConstants.colors.cta,
                styleConstants.fontFamilies.medium,
              )};
              height: 16px;
              display: flex;
              align-items: center;
            `}
          >
            {isMiddleContentOpen && (
              <Fragment>
                <SvgChevronUp
                  data-isopen="true"
                  css={css`
                    transform: scale(0.8);
                  `}
                />
                {props.bottomContent.openBottomLabel}
              </Fragment>
            )}
            {!isMiddleContentOpen && (
              <Fragment>
                <SvgChevronDown
                  data-isopen="false"
                  css={css`
                    transform: scale(0.8);
                  `}
                />
                {props.bottomContent.closedBottomLabel}
              </Fragment>
            )}
          </span>
        </div>
      )}
    </Box>
  )
}

export default CollapsibleMiddleBox
